export default {
  methods: {
    mapLayerSnowmakingHydrantslabellessAdd() {
      this.initPollSnowmakingHydrantslabelless();
      this.map.addSource("hydrantslabelless", {
        type: "geojson",
        data: this.computedSnowmakingHydrantslabellessGeoJson
      });

      this.map.addLayer({
        filter: ["==", "c_colour", "Grey"],
        id: "hydrantslabelless-grey",
        type: "circle",
        source: "hydrantslabelless",
        paint: {
          "circle-radius": 4,
          "circle-color": "Grey",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        },
        layout: {
          visibility: "visible"
        }
      });

      // HYDRANTS Black
      this.map.addLayer({
        filter: ["==", "c_colour", "Black"],
        id: "hydrantslabelless-black",
        type: "circle",
        source: "hydrantslabelless",
        paint: {
          "circle-radius": 4,
          "circle-color": "Black",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        },
        layout: {
          visibility: "visible"
        }
      });

      // HYDRANTS White
      this.map.addLayer({
        filter: ["==", "c_colour", "White"],
        id: "hydrantslabelless-white",
        type: "circle",
        source: "hydrantslabelless",
        paint: {
          "circle-radius": 4,
          "circle-color": "White",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        },
        layout: {
          visibility: "visible"
        }
      });

      // HYDRANTS Purple
      this.map.addLayer({
        filter: ["==", "c_colour", "Purple"],
        id: "hydrantslabelless-purple",
        type: "circle",
        source: "hydrantslabelless",
        paint: {
          "circle-radius": 4,
          "circle-color": "Purple",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        },
        layout: {
          visibility: "visible"
        }
      });

      // HYDRANTS Blue
      this.map.addLayer({
        filter: ["==", "c_colour", "Blue"],
        id: "hydrantslabelless-blue",
        type: "circle",
        source: "hydrantslabelless",
        paint: {
          "circle-radius": 4,
          "circle-color": "Blue",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        },
        layout: {
          visibility: "visible"
        }
      });

      // HYDRANTS Red
      this.map.addLayer({
        filter: ["==", "c_colour", "Red"],
        id: "hydrantslabelless-red",
        type: "circle",
        source: "hydrantslabelless",
        paint: {
          "circle-radius": 4,
          "circle-color": "Red",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        },
        layout: {
          visibility: "visible"
        }
      });

      // HYDRANTS Green
      this.map.addLayer({
        filter: ["==", "c_colour", "Green"],
        id: "hydrantslabelless-green",
        type: "circle",
        source: "hydrantslabelless",
        paint: {
          "circle-radius": 4,
          "circle-color": "Green",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        },
        layout: {
          visibility: "visible"
        }
      });

      // HYDRANTS None
      this.map.addLayer({
        filter: ["==", "c_colour", "None"],
        id: "hydrantslabelless-none",
        type: "circle",
        source: "hydrantslabelless",
        paint: {
          "circle-radius": 4,
          "circle-color": "White",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        },
        layout: {
          visibility: "visible"
        }
      });

      // HYDRANTS Yellow
      this.map.addLayer({
        filter: ["==", "c_colour", "Yellow"],
        id: "hydrantslabelless-yellow",
        type: "circle",
        source: "hydrantslabelless",
        paint: {
          "circle-radius": 4,
          "circle-color": "Yellow",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        },
        layout: {
          visibility: "visible"
        }
      });

      // HYDRANTS Cyan
      this.map.addLayer({
        filter: ["==", "c_colour", "Cyan"],
        id: "hydrantslabelless-49c6bc",
        type: "circle",
        source: "hydrantslabelless",
        paint: {
          "circle-radius": 4,
          "circle-color": "#49c6bc",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        },
        layout: {
          visibility: "visible"
        }
      });

      // HYDRANTS Orange
      this.map.addLayer({
        filter: ["==", "c_colour", "Orange"],
        id: "hydrantslabelless-orange",
        type: "circle",
        source: "hydrantslabelless",
        paint: {
          "circle-radius": 4,
          "circle-color": "Orange",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        },
        layout: {
          visibility: "visible"
        }
      });
    },
    // method to remove all layers and the source
    mapLayerSnowmakingHydrantslabellessRemove() {
      this.cancelPollSnowmakingHydrantslabelless();
      this.map.removeLayer("hydrantslabelless-grey");
      this.map.removeLayer("hydrantslabelless-black");
      this.map.removeLayer("hydrantslabelless-white");
      this.map.removeLayer("hydrantslabelless-purple");
      this.map.removeLayer("hydrantslabelless-blue");
      this.map.removeLayer("hydrantslabelless-red");
      this.map.removeLayer("hydrantslabelless-green");
      this.map.removeLayer("hydrantslabelless-none");
      this.map.removeLayer("hydrantslabelless-yellow");
      this.map.removeLayer("hydrantslabelless-orange");
      this.map.removeLayer("hydrantslabelless-49c6bc");
      this.map.removeSource("hydrantslabelless");
    },
    // method to create the geojson polling
    initPollSnowmakingHydrantslabelless() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/snowmaking/hydrants",
        dept: "snowmaking",
        layer: "hydrantslabelless",
        token: this.computedAuthToken
      });
      this.pollSnowmakingHydrantslabellessInterval = setInterval(() => {
        this.$store.dispatch("actionGetGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/snowmaking/hydrants",
          dept: "snowmaking",
          layer: "hydrantslabelless",
          token: this.computedAuthToken
        });
      }, this.computedInterval);
    },
    // method to cancel poll
    cancelPollSnowmakingHydrantslabelless() {
      this.pollSnowmakingHydrantslabellessInterval = clearInterval(
        this.pollSnowmakingHydrantslabellessInterval
      );
    }
  },
  computed: {
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    // the geojson
    computedSnowmakingHydrantslabellessGeoJson() {
      return this.$store.state.mapLayers.snowmaking.layers.hydrantslabelless
        .geojson;
    },
    // visibility
    computedSnowmakingHydrantslabellessMapVisibility() {
      return this.$store.state.mapLayers.snowmaking.layers.hydrantslabelless
        .visibility.mapView;
    },
    // grabs the interval from the vuex state
    computedInterval() {
      return this.$store.state.general.interval;
    },
    computedSingleView() {
      return this.$store.state.mapLayers.snowmaking.layers.hydrantslabelless
        .visibility.singleView;
    }
  },
  watch: {
    // watches the vuex state and if geojson changes removes then re-adds layers/source
    "$store.state.mapLayers.snowmaking.layers.hydrantslabelless.geojson": {
      handler() {
        if (this.computedSnowmakingHydrantslabellessMapVisibility) {
          this.mapLayerSnowmakingHydrantslabellessRemove();
          this.mapLayerSnowmakingHydrantslabellessAdd();
        }
      }
    },
    // watches the vuex state of visibility and adds or removes the layer/source
    "$store.state.mapLayers.snowmaking.layers.hydrantslabelless.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerSnowmakingHydrantslabellessAdd();
      } else {
        this.mapLayerSnowmakingHydrantslabellessRemove();
      }
    }
  },
  beforeDestroy() {
    // cancels poll on component destroy
    this.cancelPollSnowmakingHydrantslabelless();
  }
};
